import { Page } from "modules/Page";

export class CampaignPage extends Page<typeof CampaignPage> {
    public static readonly className = "js-campaign-page";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.removeFooterElement();
        this.addAnchorLinks();
    }

    public removeFooterElement(): void {
        const footerElement = document.querySelector<HTMLDivElement>('.footer__language');
        if (footerElement) {
            footerElement.style.display = 'none';
        }
    }

    public addAnchorLinks(): void {
        const html = document.querySelector("html");
        const anchorBar = this.rootElement.querySelector(".anchor-bar ul");
        const anchorLinkItems = this.rootElement.querySelectorAll(".anchor-link-item-block");
      
        if (html) {
            html.classList.add("html-scroll__smooth");
        }

        if (anchorBar && anchorLinkItems.length != 0) {

            // Create list items for each block
            anchorLinkItems.forEach((block) => {
                
                const listItem = document.createElement("li");
                const link = document.createElement("a");

                const blockId = block.querySelector("span")?.getAttribute("id");
                const blockText = block.querySelector("span")?.innerHTML;
               
                if (blockId && blockText) {
                    link.setAttribute("href", "#" + blockId);
                    link.innerHTML = blockText;
                }

                if (listItem) {
                    listItem.appendChild(link);
                    anchorBar.appendChild(listItem);
                }

            });

            const anchorLinks = this.rootElement.querySelectorAll(".anchor-links li");

            //Handle tab click events
            anchorLinks?.forEach((link) => {
                link.addEventListener("click", () => {
                    const isActive = link.classList.contains("active");

                    if (isActive) {
                        return
                    }

                    anchorLinks.forEach((otherTab) => otherTab.classList.remove("active"));

                    if (!isActive) {
                        link.classList.add("active");

                        if (document.documentElement.clientWidth < 800) {
                            const tabWrapper = link.parentElement?.parentElement;

                            if (tabWrapper != null) {
                                tabWrapper.scrollTo({
                                    top: 0,
                                    left: (link as HTMLElement).offsetLeft - 15,
                                    behavior: 'smooth'
                                });
                            }
                        }
                    }
                });
            });
        }
    }
}